import { render, staticRenderFns } from "./PastFair.vue?vue&type=template&id=e2ce20a2&scoped=true"
import script from "./PastFair.vue?vue&type=script&lang=js"
export * from "./PastFair.vue?vue&type=script&lang=js"
import style0 from "./PastFair.vue?vue&type=style&index=0&id=e2ce20a2&prod&scoped=true&lang=scss"
import style1 from "./PastFair.vue?vue&type=style&index=1&id=e2ce20a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ce20a2",
  null
  
)

export default component.exports